export interface IDestination {
  value: string;
  locKey: string;
}

export interface IDestinationGroup {
  locKey: string;
  items: IDestination[];
}

export interface IDestinationGroups {
  mostPopular: IDestinationGroup;
  other: IDestinationGroup;
}

export const DESTINATION_GROUPS: IDestinationGroups = {
  mostPopular: {
    locKey: 'Most Popular',
    items: [
      { value: 'caribbean', locKey: 'Caribbean' },
      { value: 'bahamas', locKey: 'Bahamas' },
      { value: 'mexico', locKey: 'Mexico' },
      { value: 'alaska', locKey: 'Alaska' },
      { value: 'europe', locKey: 'Europe' },
      { value: 'bermuda', locKey: 'Bermuda' },
      { value: 'hawaii', locKey: 'Hawaii' },
      { value: 'canada-new-england', locKey: 'Canada / New England' },
    ],
  },
  other: {
    locKey: 'Other Destinations',
    items: [
      { value: 'arctic-antarctic', locKey: 'Arctic Antarctic' },
      { value: 'middle-east', locKey: 'Middle East' },
      { value: 'africa', locKey: 'Africa' },
      { value: 'panama-canal', locKey: 'Panama Canal' },
      { value: 'asia', locKey: 'Asia' },
      { value: 'pacific-coastal ', locKey: 'Pacific Coastal' },
      { value: 'australia-new-zealand', locKey: 'Australia / NewZealand' },
      { value: 'central-america', locKey: 'Central America' },
      { value: 'galapagos', locKey: 'Galapagos' },
      { value: 'getaway-at-sea', locKey: 'Getaway at Sea' },
      { value: 'transatlantic', locKey: 'Transatlantic' },
      { value: 'world-cruise ', locKey: 'World' },
      { value: 'south-america', locKey: 'South America' },
      { value: 'south-pacific ', locKey: 'South Pacific' },
      { value: 'transpacific', locKey: 'Transpacific' },
    ],
  },
};

export const CRUISE_ADVISOR_CONTACT = '1-800-916-8586';
